import { render, staticRenderFns } from "./HeaderFooterEditor.vue?vue&type=template&id=6b5d3397"
import script from "./HeaderFooterEditor.vue?vue&type=script&lang=js"
export * from "./HeaderFooterEditor.vue?vue&type=script&lang=js"
import style0 from "./HeaderFooterEditor.vue?vue&type=style&index=0&id=6b5d3397&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports